module.exports = [
  {
    "code": "SL",
    "name": "Slip Lead",
    "description": "Head movement to your lead hand side (left for orthodox, right for southpaw)",
    "types": ["defense", "lead"]
  },

  {
    "code": "DL",
    "name": "Duck Lead",
    "description": "Duck under (often a hook) to your lead hand side (left for orthodox, right for southpaw)",
    "types": ["defense", "lead"]
  },

  {
    "code": "BL",
    "name": "Block Lead",
    "description": "Block (often a hook) on your lead hand side (left for orthodox, right for southpaw)",
    "types": ["defense", "lead"]
  },

  {
    "code": "SR",
    "name": "Slip Rear",
    "description": "Head movement to your rear hand side (right for orthodox, left for southpaw)",
    "types": ["defense", "rear"]
  },

  {
    "code": "DR",
    "name": "Duck Rear",
    "description": "Duck under (often a hook) to your rear hand side (right for orthodox, left for southpaw)",
    "types": ["defense", "rear"]
  },

  {
    "code": "BR",
    "name": "Block Rear",
    "description": "Block (often a hook) on your rear hand side (right for orthodox, left for southpaw)",
    "types": ["defense", "rear"]
  },

  {
    "code": "P",
    "name": "Pull",
    "description": "Pull back your upper body to avoid a punch",
    "types": ["defense"]
  },

  {
    "code": "1",
    "name": "Jab",
    "description": "A short, straight punch with your lead hand (left for orthodox, right for southpaw)",
    "types": ["offense", "head", "lead"]
  },

  {
    "code": "1o",
    "name": "Overhand jab",
    "description": "A slightly higher and rounder jab that goes around and over your opponent's offense or defense",
    "types": ["offense", "head", "lead"]
  },

  {
    "code": "2",
    "name": "cross",
    "description": "A short, straight punch with your rear hand (right for orthodox, left for southpaw)",
    "types": ["offense", "head", "rear"]
  },

  {
    "code": "2o",
    "name": "Overhand Cross",
    "description": "A slightly higher and rounder cross that goes around and over your opponent's offense or defense",
    "types": ["offense", "head", "rear"]
  },

  {
    "code": "3",
    "name": "Lead Hook",
    "description": "A rounded punch aimed at the side of the head with your lead hand (left for orthodox, right for southpaw)",
    "types": ["offense", "head", "lead"]
  },

  {
    "code": "4",
    "name": "Rear Hook",
    "description": "A rounded punch aimed at the side of the head with your rear hand (right for orthodox, left for southpaw)",
    "types": ["offense", "head", "rear"]
  },

  {
    "code": "5",
    "name": "Lead Uppercut",
    "description": "A power punch aimed at the chin with your lead hand (left for orthodox, right for southpaw)",
    "types": ["offense", "head", "lead"]
  },

  {
    "code": "6",
    "name": "Rear Uppercut",
    "description": "A power punch aimed at the chin with your rear hand (right for orthodox, left for southpaw).",
    "types": ["offense", "head", "rear"]
  },

  {
    "code": "7",
    "name": "Jab Body",
    "description": "A jab to the body",
    "types": ["offense", "body", "lead"]
  },

  {
    "code": "8",
    "name": "Cross Body",
    "description": "A cross to the body",
    "types": ["offense", "body", "rear"]
  },

  {
    "code": "9",
    "name": "Lead Hook Body",
    "description": "A lead hook to the side of the body",
    "types": ["offense", "body", "lead"]
  },

  {
    "code": "10",
    "name": "Rear Hook Body",
    "description": "A rear hook to the side of the body",
    "types": ["offense", "body", "rear"]
  },

  {
    "code": "11",
    "name": "Lead Shovel Hook",
    "description": "A mix of uppercut and hook that digs at a 45 degree angle into your opponent's side (sometimes called a liver shot)",
    "types": ["offense", "body", "lead"]
  },

  {
    "code": "12",
    "name": "Rear Shovel Hook",
    "description": "A mix of uppercut and hook that digs at a 45 degree angle into your opponent's side (sometimes called a liver shot)",
    "types": ["offense", "body", "rear"]
  }

]